import { Autocomplete, TextField } from "@mui/material";
import type { ValidationResult } from "@entrilia/shared/utilities/validators";
import type { OrganizationInfo } from "../../api/clientsManagementTypes";

interface Props {
  organizations: OrganizationInfo[];
  value: OrganizationInfo | null;
  onChange: (organization: OrganizationInfo | null) => void;
  validationResult?: ValidationResult;
}

const OrganizationSelector = ({ organizations, value, onChange, validationResult }: Props) => {
  return (
    <Autocomplete
      fullWidth
      options={organizations}
      value={value}
      onChange={(_, value) => onChange(value)}
      getOptionLabel={(option) => `${option.name} - ${option.clientCode}`}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Organization"
          error={validationResult?.isValid === false}
          helperText={validationResult?.error}
        />
      )}
    />
  );
};

export default OrganizationSelector;
